var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatBubbleOutlineAccent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 2.73901H4.5C3.2625 2.73901 2.25 3.71401 2.25 4.90568V24.4057L6.75 20.0723H22.5C23.7375 20.0723 24.75 19.0973 24.75 17.9057V4.90568C24.75 3.71401 23.7375 2.73901 22.5 2.73901ZM21.375 17.9057H6.75L4.5 20.0723V5.98901C4.5 5.39318 5.00625 4.90568 5.625 4.90568H21.375C21.9937 4.90568 22.5 5.39318 22.5 5.98901V16.8223C22.5 17.4182 21.9937 17.9057 21.375 17.9057Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBubbleOutlineAccent);
export default __webpack_public_path__ + "static/media/chat-bubble-outline-accent.799cbbb4ecd92211bfc851e9563e7244.svg";
export { ForwardRef as ReactComponent };